import { render, staticRenderFns } from "./UserStatsPage.vue?vue&type=template&id=8029bac0"
import script from "./UserStatsPage.vue?vue&type=script&lang=js"
export * from "./UserStatsPage.vue?vue&type=script&lang=js"
import style0 from "./UserStatsPage.vue?vue&type=style&index=0&id=8029bac0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports